import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import { UTCToLocalDate } from "../../utilis/date-formats";
import styles from "./ActivityLogTooltip.module.scss";

const formatActionLabel = (text) => {
	if (!text || typeof text !== "string") return "—";
	const trimmed = text.trim();
	if (!trimmed) return "—";
	return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};

export default function ActivityLogTooltip({ logs = [] }) {
	const safeLogs = Array.isArray(logs) ? logs : [];

	return (
		<div className={styles.root}>
			<div className={styles.header}>
				<span className={styles.headerIcon} aria-hidden>
					<HistoryOutlinedIcon sx={{ fontSize: 16 }} />
				</span>
				<h6 className={styles.headerTitle}>Activity Log</h6>
				{safeLogs.length > 0 && (
					<span className={styles.headerCount}>{safeLogs.length}</span>
				)}
			</div>

			{safeLogs.length > 0 ? (
				<div className={styles.tableWrap}>
					<table className={styles.table}>
						<thead className={styles.thead}>
							<tr>
								<th className={styles.th}>Name</th>
								<th className={styles.th}>Action</th>
								<th className={styles.th}>Date</th>
							</tr>
						</thead>
						<tbody>
							{safeLogs.map((entry, idx) => (
								<tr key={entry?._id ?? entry?.id ?? `log-${idx}`} className={styles.row}>
									<td className={styles.td}>
										<span className={styles.name} title={entry?.userName || ""}>
											{entry?.userName || "—"}
										</span>
									</td>
									<td className={styles.td}>
										<span
											className={styles.action}
											title={formatActionLabel(entry?.description)}
										>
											{formatActionLabel(entry?.description)}
										</span>
									</td>
									<td className={styles.td}>
										<span className={styles.date}>
											{entry?.date
												? UTCToLocalDate(entry.date, "MM/DD/YYYY hh:mm A")
												: "—"}
										</span>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			) : (
				<div className={styles.empty}>
					<p className={styles.emptyTitle}>No activity yet</p>
					<p className={styles.emptyHint}>Changes to this record will appear here.</p>
				</div>
			)}
		</div>
	);
}
